import l from "./index.es237.js";
import { forwardRef as i, createElement as c } from "react";
import d from "react-dom";
import { Primitive as f } from "./index.es247.js";
const b = /* @__PURE__ */ i((e, t) => {
  var o;
  const { container: r = globalThis == null || (o = globalThis.document) === null || o === void 0 ? void 0 : o.body, ...a } = e;
  return r ? /* @__PURE__ */ d.createPortal(/* @__PURE__ */ c(f.div, l({}, a, {
    ref: t
  })), r) : null;
});
export {
  b as Portal
};
//# sourceMappingURL=index.es245.js.map
